// Alle Painter registrieren (Reihenfolge: Basis zuerst)
import { painters } from './painters.ts';
import './painters-harbor.ts';
export { painters };
import './painters-town.ts';
import './painters-deco.ts';

/** Painter späterer Kapitel werden erst nachgeladen, wenn eine Szene sie braucht (schneller Start) */
let extra: Promise<unknown> | null = null;
export function loadExtraPainters() {
  return (extra ??= import('./painters-extra.ts'));
}
export async function ensurePainters(names: Iterable<string>) {
  for (const n of names) if (!painters[n]) return void (await loadExtraPainters());
}
